import { createSelector } from 'reselect';

const getState = (state) => state.addresses;

const getLoadedAddresses = createSelector(
  getState,
  (state) => state.loadedAddresses.data
);

const getTotalLoadedAddresses = createSelector(
  getState,
  (state) => state.loadedAddresses.count
);

const getLoadedAddressesNextUrl = createSelector(
  getState,
  (state) => state.loadedAddresses.next
);

const getLoadedVenuesOfInterest = createSelector(
  getState,
  (state) => state.loadedPointsOfInterest.venues
);

const getLoadedAddressesOfInterest = createSelector(
  getState,
  (state) => state.loadedPointsOfInterest.addresses
);

const getPreLoadedAddresses = createSelector(
  getState,
  (state) => state.preLoadedAddresses
);

const getCityLabel = createSelector(getState, (state) => state.cityData.label);

const getCityData = createSelector(getState, (state) => state.cityData);

const isZipCodeEnabled = createSelector(
  getState,
  (state) => !!state.cityData.enabled
);

export default {
  getLoadedAddresses,
  getTotalLoadedAddresses,
  getLoadedAddressesNextUrl,
  getLoadedVenuesOfInterest,
  getLoadedAddressesOfInterest,
  getPreLoadedAddresses,
  isZipCodeEnabled,
  getCityLabel,
  getCityData,
};
